import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import TournamentsCommentsNavigator from "../../../navigation/TournamentsCommentsNavigator";
import styles from "./tournamentComments.module.css";

const TournamentsComments = () => {
  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/tournaments-comments/show-comments-reports">
              ابلاغات التعلقيات
            </PageLink>
          </div>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/tournaments-comments/previous-reports">
              الابلاغات السابقة
            </PageLink>
          </div>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/tournaments-comments/all-comments">
              جميع التعليقات
            </PageLink>
          </div>
        </div>
      </HorizantalBar>
      <TournamentsCommentsNavigator />
    </div>
  );
};

export default TournamentsComments;
